import jwtDecode from 'jwt-decode';
import axios from 'axios';
import { IAM_API_URL } from 'Constants/apis';
import * as ACTION_TYPES from 'Redux/modules/auth/types';

const reservedTime = 20000;

let isRefreshing = false;
let bufferActions = [];
let bufferPromiseResolve = [];

const getRefreshToken = refreshToken => {
  return axios.post(`${IAM_API_URL}/auth/refresh`, {
    refresh_token: refreshToken,
  });
};

const authenMiddleware =
  ({ dispatch, getState }) =>
  next =>
  async action => {
    const { data: authData } = getState().auth;

    if (authData.token) {
      const tokenInfo = jwtDecode(authData.token);
      const currentTime = new Date().getTime();
      const isExpired = tokenInfo.exp * 1000 - reservedTime < currentTime;

      if (isExpired) {
        // If this action is a combo of three sub action (used for RESTful api)
        if (action?.types) {
          bufferActions.push(action);
          const promise = new Promise((resolve, reject) => {
            bufferPromiseResolve.push(resolve);
            if (isRefreshing === false) {
              isRefreshing = true;
              getRefreshToken(authData.refreshToken)
                .then(data => {
                  dispatch({
                    type: ACTION_TYPES.UPDATE_ACCESS_TOKEN_SUCCESS,
                    payload: data.data,
                  });

                  // Right after we have a new access token, resolve all pending a ctions.
                  bufferActions.forEach((elem, index) => {
                    const pendingResolve = bufferPromiseResolve[index];
                    pendingResolve(next(elem));
                  });
                })
                .catch(error => {
                  dispatch({ type: ACTION_TYPES.UPDATE_ACCESS_TOKEN_FAILED });
                })
                .finally(() => {
                  bufferActions = [];
                  bufferPromiseResolve = [];
                  isRefreshing = false;
                });
            }
          });

          // return promise pending until it is be resolved
          return promise;
        }

        // It this action is normal action, we do not postpone it. Let it goes.
        if (!action.types) {
          return next(action);
        }
      } else {
        // If access token is still alive, let it goes.
        return next(action);
      }
    } else {
      // if not appointment auhen
      return next(action);
    }
  };

export default authenMiddleware;
